import axios from 'axios';
import { get, set, values, clear } from 'idb-keyval';
import offlineStore from 'utils/OfflineDB';
import offlineTrfStore from 'utils/offlineTrfStoreDB';
import imageStore from 'utils/ImageDB';
import { APIEndpoints } from 'helpers/APILists';
import { Trim, MatchSRA } from 'helpers/Validation';
import { MESSAGE_TYPE } from '../../common/common.constants';
import { FORM_ACTIONS } from './Forms.constants';
import { formDataInitialState } from './Forms.data';
import { getAllDPSData } from '../SubSections/DPS/DPS.actions';
import { getTestMakeModelData } from '../TestEquipment/TestEquipment.actions';
import { getTotalRecordsSavedOffline } from './Forms.actions';
import { getAllTRFFormImage } from './TRFImaging.actions';

const processP8FormData = (res, selectedTag, TRFId) => {
    const { data } = res;
    const fetchFormData = typeof data === 'string'
        ? data
        : data.find((item) => (item.F20Mo === selectedTag.HdWorkOrder)
            && (item.F86Mi === selectedTag.Mi
                || item.F17Mi === selectedTag.Mi));
    const resultFormData = fetchFormData ?? formDataInitialState;
    return TRFId === 'P8-1' ? {
        tableLoading: false,
        formData: resultFormData,
        formDataP81: resultFormData,
    } : {
        tableLoading: false,
        formData: resultFormData,
        formDataSRA: resultFormData,
    };
};

const fetchFormDraftDataP8 = async (uniqueFormName, dispatch) => {
    let dataSRA = await get(`Forms_${uniqueFormName}_SRA`, offlineStore) ?? await get(`Forms_${uniqueFormName}`, offlineStore);
    if (!dataSRA) {
        dataSRA = await get(`Forms_${uniqueFormName}`, offlineTrfStore);
    }
    let dataP81 = await get(`Forms_${uniqueFormName}_P81`, offlineStore);
    if (!dataP81) {
        dataP81 = await get(`Forms_${uniqueFormName}_P81`, offlineTrfStore);
    }
    const resultFormData = dataSRA?.body ?? formDataInitialState;
    const resultFormDataP81 = dataP81?.body;

    dispatch({
        type: FORM_ACTIONS.GET_ITF_FORM_OFFLINE_SUCCESS,
        payload: {
            tableLoading: false,
            formDataSRA: resultFormData,
            formData: resultFormData,
            formDataP81: resultFormDataP81
        }
    });
    return resultFormData;
};

const fetchFormofflineDataP8 = async (uniqueFormName, dispatch) => {
    let data = await get(`Forms_${uniqueFormName}`, offlineStore);
    if (!data) {
        data = await get(`Forms_${uniqueFormName}`, offlineTrfStore);
    }
    const resultFormData = data?.body ?? formDataInitialState;
    dispatch({
        type: FORM_ACTIONS.GET_ITF_FORM_OFFLINE_SUCCESS,
        payload: {
            tableLoading: false,
            formData: resultFormData,
        }
    });
    return resultFormData;
};

export const GetP8ITFForm = ({ uniqueFormName, HdLocation, currentTrfId }) => async (dispatch, getState) => {
    const { AppData: { isMRATOnline }, Forms: { selectedTag, selectedTrfId }, Home: { currentView } } = getState();
    const newTrfId = selectedTrfId ?? Trim(selectedTag.TrfId);
    const MO = selectedTag?.HdWorkOrder;
    return new Promise((resolve, reject) => {
        dispatch({
            type: FORM_ACTIONS.GET_ITF_FORM_PENDING,
            payload: {
                tableLoading: true
            }
        });
        dispatch(getTotalRecordsSavedOffline());
        if (isMRATOnline) {
            dispatch(getAllP8MOImages());
            dispatch(getAllTRFFormImage());
            dispatch(getAllDPSData());
            dispatch(getTestMakeModelData());
            const TRFId = currentView === 'P8-1' && MatchSRA(Trim(newTrfId)) ? 'P8-1' : newTrfId.trim();
            const filterData = { TrfId: TRFId, HdLocation: HdLocation ?? '', MO };
            axios.post(APIEndpoints.GetITFForm, filterData)
                .then((res) => {
                    const payload = processP8FormData(res, selectedTag, TRFId);
                    dispatch({
                        type: FORM_ACTIONS.GET_ITF_FORM_SUCCESS,
                        payload
                    });
                    resolve(payload.formData);
                }).catch(() => {
                    reject();
                });
        } else if (currentView === 'P8-1' && MatchSRA(Trim(newTrfId))) {
            get(`Forms_${uniqueFormName}_P81`, offlineStore).then((data) => {
                const resultFormData = data?.body ?? formDataInitialState;
                dispatch({
                    type: FORM_ACTIONS.GET_ITF_FORM_OFFLINE_SUCCESS,
                    payload: {
                        tableLoading: false,
                        formDataP81: resultFormData,
                        formData: resultFormData,
                    }
                });
                resolve(resultFormData);
            })
                .catch(() => {
                    reject();
                });
        } else if (MatchSRA(currentView)) {
            resolve(fetchFormDraftDataP8(uniqueFormName, dispatch));
        } else {
            resolve(fetchFormofflineDataP8(uniqueFormName, dispatch));
        }
    });
};

export const getAllP8MOImages = () => async (dispatch, getState) => {
    const { AppData: { isMRATOnline }, Forms: { selectedTag } } = getState();
    dispatch({
        type: FORM_ACTIONS.GETIMAGES_PENDING
    });
    if (isMRATOnline) {
        const filterData = { MO: selectedTag.HdWorkOrder, Mi: selectedTag.Mi ?? null, HdLocation: selectedTag.HdLocation };
        await axios.post(APIEndpoints.GetImages, filterData)
            .then((res) => {
                res.data.map((data) => set(data.ImageId, data, imageStore));
                dispatch({
                    type: FORM_ACTIONS.GETIMAGES_SUCCESS
                });
            }).catch((err) => dispatch({
                type: FORM_ACTIONS.GETIMAGES_FAILURE,
                meta: { messageType: MESSAGE_TYPE.ERROR, message: err.message, exception: err }
            }));
    } else {
        const offlineStoreData = await values(offlineStore);
        for await (const data of offlineStoreData) {
            if (data.url.includes('SubmitImages')) {
                await set(data.body.ImageId, data.body, imageStore);
            }
        }
    }
};

export const setP81FormData = (formData) => (dispatch) => {
    dispatch({
        type: FORM_ACTIONS.SET_P81_FORMDATA,
        payload: {
            formDataP81: formData
        }
    });
};

export const setSRAFormData = (formData) => (dispatch, getState) => {
    const { Forms: { updatedFormDataObj } } = getState();
    dispatch({
        type: FORM_ACTIONS.SET_SRA_FORMDATA,
        payload: {
            formDataSRA: { ...formData, ...updatedFormDataObj }
        }
    });
};

export const clearSRAData = () => (dispatch) => {
    dispatch({
        type: FORM_ACTIONS.CLEAR_SRA_FORMDATA,
        payload: {
            formData: formDataInitialState,
            deleteExistingImageList: [],
            deleteNewImageList: [],
            newImageList: [],
            formDataP81: {},
            formDataSRA: {},
            P8TRFImage: {},
        }
    });
    clear(imageStore);
};
